// Static seat layout for the Irish Office Ground Floor.
// Seat assignments themselves (which user sits where) are stored server-side
// via the floor_plan_seats API - this file only describes the physical layout.
// Seat keys are prefixed with "g" so they never collide with 1st Floor keys.

import { seatBlock } from './seatLayout';

// Top-left: two stacked seat blocks
export const topGroupA = seatBlock('ga', 1, 2, 4);

// Second top block: a single tall seat on each end (spanning both rows)
// bookending a 3-column, 2-row middle grid.
export const topGroupB = {
    left: { key: 'ga-2-tall-1', label: 'GA2-T.1' },
    middle: seatBlock('ga', 2, 2, 4),
    right: { key: 'ga-2-tall-2', label: 'GA2-T.2' },
};

// Small block next to Aarons Office
export const smallMidGroup = seatBlock('gc', 1, 1, 1);

// Aarons Office is a single-occupant seat, not a plain seat block.
export const aaronsOfficeSeat = { key: 'g-office-aarons', label: "Aaron's Office" };

// Left column: two stacked blocks (mid + lower)
export const midLeftGroup = seatBlock('gd', 1, 2, 4);
export const lowerGroup = seatBlock('gd', 3, 2, 4);

// Right column (near Canteen): two stacked blocks, aligned to the right
export const midRightGroup = seatBlock('gd', 2, 2, 3);
export const lowerRightGroup = seatBlock('gd', 4, 2, 3);

// Footer strip: small blocks before the Meeting Room
export const footerGroupA = seatBlock('gf', 1, 1, 2);
export const footerGroupC = seatBlock('gf', 3, 1, 1);

// Roughly locates a seat key within the layout so unit bubbles can be placed
// on the left or right rail of the Ground Floor tab.
export function parseGroundSeatKey(seatKey) {
    const [prefix, group] = seatKey.split('-');
    const groupIndex = Number(group) || 0;
    const groupKey = `${prefix}-${groupIndex}`;
    if (prefix === 'gd' && (groupIndex === 2 || groupIndex === 4)) {
        return { side: 'right', groupIndex, groupKey };
    }
    return { side: 'left', groupIndex, groupKey };
}

export const allGroundFloorSeats = [
    ...topGroupA.flat(),
    topGroupB.left,
    ...topGroupB.middle.flat(),
    topGroupB.right,
    aaronsOfficeSeat,
    ...smallMidGroup.flat(),
    ...midLeftGroup.flat(),
    ...midRightGroup.flat(),
    ...lowerGroup.flat(),
    ...lowerRightGroup.flat(),
    ...footerGroupA.flat(),
    ...footerGroupC.flat(),
];
